import React, { useEffect, useState } from "react";
import "./Myaccount.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { newcolor } from "../../constants/color";

import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
//done
const Myaccount = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const token = localStorage.getItem("raer_token");

  useEffect(() => {
    if (!tokena) {
      navigate("/login");
    }
  }, []);
  const [getAmountValue, setGetAmountValue] = useState(false);
  const [walletTran, setWalletTran] = useState([]);

  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const handleChange = (num) => {
    setValue(num);
  };

  const onLogOut = () => {
    console.log(userId);

    const config = {
      url: process.env.REACT_APP_BASE_URL + "auth/logout",
      method: "post",
      data: {
        userId: userId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          localStorage.clear();
          navigate("/");
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [userData, setUserData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    landmark: "",
    state: "",
    pincode: "",
  });
  const getUserData = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `auth/user/${userId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          const {
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          } = response?.data?.data;
          setUserData({
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handleChangeUserInfo = (e) => {
    const { name, value } = e.target;

    setUserData({
      ...userData,
      [name]: value.trim(),
    });

    console.log(userData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(userData);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `auth/updateUser/${userId}`,
      method: "put",
      data: userData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          const {
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          } = response?.data?.data;
          setUserData({
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          });

          // toast.success("User data updated successfully", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Failed to update user data", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Failed to update user data", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Failed to update user data", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Failed to update user data", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [amount, setAmount] = useState(0);
  const addWalletAmount = () => {
    if (!tokena) {
      navigate("/login");
      return;
    }

    setGetAmountValue(false);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/createWallet`, // this is userId
      method: "post",
      data: {
        userId: userId,
        amount: amount,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        if (response?.data?.status == true) {
          // navigate(response?.data?.data);
          window.location.href = response.data.data;
          // toast.success("Your Payment donw", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [walletAmount, setWalletAmount] = useState(0);

  const getWalletInfo = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getWalletById/${userId}`, // this is userId
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setWalletAmount(response?.data?.data?.amount);
          setWalletTran(response?.data?.data?.tran);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [orderDetail, setOrderDetail] = useState([]);
  const getOrderHistory = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getAllOrderByUser/${userId}`, // this is userId
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setOrderDetail(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [returnOrder, setReturnOrder] = useState([]);
  const ReturnOrderHistory = () => {
    const config = {
      url:
        process.env.REACT_APP_BASE_URL + `return/getAllReturnOrder/${userId}`, // this is userId
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setReturnOrder(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getUserData();
  }, [userId]);

  useEffect(() => {
    getWalletInfo();
    getOrderHistory();
    ReturnOrderHistory();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // to rander
  useEffect(() => {
    setValue(1);
    const OrderPart = window.location.OrderPart;
    if (OrderPart) {
      const element = document.getElementById(OrderPart.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);
  return (
    <div>
      <div className="myaccount-outer">
        <div className="myaccount-inner row ">
          {/* 1111 */}
          <div className="myaccount-head col-sm-10 col-md-3">
            <div className="head-inner">
              <div
                className={`head ${value === 0 ? "active-tab" : ""}`}
                onClick={() => {
                  handleChange(0);
                }}
              >
                <h6>Dashboard</h6>
              </div>
              <div
                className={`head ${value === 1 ? "active-tab" : ""}`}
                onClick={() => {
                  handleChange(1);
                }}
              >
                <h6>Order</h6>
              </div>
              <div
                className={`head ${value === 2 ? "active-tab" : ""}`}
                onClick={() => {
                  handleChange(2);
                }}
              >
                <h6>Return Order</h6>
              </div>
              <div
                className={`head ${value === 3 ? "active-tab" : ""}`}
                onClick={() => {
                  handleChange(3);
                }}
              >
                <h6>My Wallet</h6>
              </div>
              <div
                className={`head ${value === 4 ? "active-tab" : ""}`}
                onClick={() => {
                  handleChange(4);
                }}
              >
                <h6>Account Details</h6>
              </div>
              <div
                className={`head ${value === 5 ? "active-tab" : ""}`}
                onClick={onLogOut}
              >
                <h6>Logout</h6>
              </div>
            </div>
          </div>
          {/* 2222 */}
          <div className="myaccount-body col-sm-12 col-md-9">
            {value === 0 && (
              <div className="dashboard">
                <div className="dashboard-outer">
                  <div className="section-2">
                    <div className="section-outer-2"></div>
                  </div>
                  <div className="section-1  mt-5">
                    <div className="section-outer-1 ">
                      <div className="sec-1">
                        <div className="icon-part">
                          <i class="bi bi-person-circle"></i>
                        </div>
                        <div className="name-part ">
                          <h4>Hello</h4>
                          <h4>
                            {userData?.fullName &&
                              userData.fullName.split(" ")[0]}
                          </h4>
                        </div>
                      </div>

                      <hr />
                      <div className="detail-part">
                        <div className="email">
                          <h6>
                            Full Name : <span>{userData?.fullName}</span>
                          </h6>
                        </div>
                        <div className="email">
                          <h6>
                            Email : <span>{userData?.email}</span>
                          </h6>
                        </div>
                        <div className="email">
                          <h6>
                            Phone : <span>{userData?.phone}</span>
                          </h6>
                        </div>
                        <div className="email">
                          <h6>
                            Country : <span>India</span>
                          </h6>
                        </div>
                        <div className="email">
                          <h6>
                            Postcode : <span>{userData?.pincode}</span>
                          </h6>
                        </div>
                      </div>
                      <div className="edit-part text-center">
                        <button
                          onClick={() => {
                            handleChange(4);
                          }}
                        >
                          Edit Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {value === 1 && (
              <div className="order" id="OrderPart">
                <div className="section-outer-2">
                  <div className="order-part">
                    <div className="order-outer">
                      <div className="head">
                        <h5>Order History</h5>
                      </div>
                      <hr />
                      <div className="body">
                        <div className="body-top row">
                          <div className="order-head col-md-5 col-3">
                            <h6>ORDER Date</h6>
                          </div>
                          {/* <div className="date-head col-md-2 col-4">
                            <h6>DATE</h6>
                          </div> */}
                          <div className="status-head col-md-3 col-4">
                            <h6>STATUS</h6>
                          </div>
                          <div className="total-head col-md-2">
                            <h6>TOTAL</h6>
                          </div>
                          <div className="total-head col-md-2">
                            <h6>ACTION</h6>
                          </div>
                        </div>
                        <hr />
                        <div className="body-bottom">
                          {orderDetail?.map((order, index) => (
                            <div className="body-button-outer row" key={index}>
                              <div className="order-body col-md-1 col-2">
                                <p>{index + 1}</p>
                              </div>
                              <div className="date-body col-md-4 col-5">
                                <p>{formatDate(order?.orderDate)}</p>
                              </div>
                              <div className="status-body col-md-3 col-4">
                                <p>{order?.orderStatus}</p>
                              </div>
                              <div className="total-body col-md-2">
                                <p>{order?.total_amount}</p>
                              </div>
                              <div className="action-body col-md-2 col-3 row">
                                <div className="view  col-md-12 col-8">
                                  <button
                                    className="view-but"
                                    onClick={() => {
                                      navigate(
                                        `/orderConfirmation/${order._id}`
                                      );
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </div>
                        {/* <div className="body-next text-end border-4">
                          <button>NEXT</button>
                        </div> */}
                      </div>
                      {/* for the mobile width */}
                      <div className="bodysecond">
                        <div className="body-top row">
                          <div className="order-head col-md-5 col-3">
                            <h6>ORDER Date</h6>
                          </div>
                          {/* <div className="date-head col-md-2 col-4">
                            <h6>DATE</h6>
                          </div> */}
                          <div className="status-head col-md-3 col-4">
                            <h6>STATUS</h6>
                          </div>
                          <div className="total-head col-md-2">
                            <h6>TOTAL</h6>
                          </div>
                          <div className="total-head col-md-2">
                            <h6>ACTION</h6>
                          </div>
                        </div>
                        <hr />
                        <div className="body-bottom">
                          {orderDetail?.map((order, index) => (
                            <div className="body-button-outer row" key={index}>
                              <div className="order-body col-md-1 col-2">
                                <p>{index + 1}</p>
                              </div>
                              <div className="date-body col-md-4 col-5">
                                <p>{formatDate(order?.orderDate)}</p>
                              </div>
                              <div className="status-body col-md-3 col-4">
                                <p>{order?.orderStatus}</p>
                              </div>
                              <div className="total-body col-md-2">
                                <p>{order?.total_amount}</p>
                              </div>
                              <div className="action-body col-md-2 col-3 row">
                                <div className="view  col-md-12 col-8">
                                  <button
                                    className="view-but"
                                    onClick={() => {
                                      navigate(
                                        `/orderConfirmation/${order._id}`
                                      );
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </div>
                        {/* <div className="body-next text-end border-4">
                          <button>NEXT</button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* under 768 for */}
                <div className="section-outer-22">
                  <div className="order-part22">
                    <div className="order-outer22">
                      <div className="head">
                        <h5>Order History</h5>
                      </div>
                      <hr />
                      <div className="body">
                        <div className="body-bottom">
                          {orderDetail?.map((order, index) => (
                            <div className="body-button-outer row" key={index}>
                              <div className="date-body col-sm-6 col-md-4  col-lg-6">
                                <p>
                                  {index + 1}.&nbsp;
                                  <b> Order date :</b>&nbsp;&nbsp;
                                  {formatDate(order?.orderDate)}
                                </p>
                              </div>
                              <div className="status-body col-sm-6 col-md-4  col-lg-6">
                                <p>
                                  {" "}
                                  &nbsp;&nbsp; &nbsp;&nbsp;
                                  <b>Status :</b> &nbsp; {order?.orderStatus}
                                </p>
                              </div>
                              <div className="total-body col-sm-6 col-md-4  col-lg-6">
                                <p>
                                  &nbsp;&nbsp; &nbsp;&nbsp;
                                  <b>Price :</b> RS {order?.total_amount}/-
                                </p>
                              </div>
                              <div className="action-body col-sm-6  col-md-4  col-lg-6 pb-2 text-end">
                                {/* <div className="view   text-end"> */}
                                <button
                                  className="view-but rounded  col-md-3 col-4"
                                  // style={{ border: "1px solid black" }}
                                  onClick={() => {
                                    navigate(`/orderConfirmation/${order._id}`);
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  View
                                </button>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {value === 2 && (
              <div className="order">
                <div className="section-outer-2">
                  <div className="order-part">
                    <div className="order-outer">
                      <div className="head">
                        <h5>Return Order History</h5>
                      </div>
                      <hr />
                      <div className="body">
                        <div className="body-top row">
                          <div className="order-head col-md-1 col-3">
                            <h6>ORDER</h6>
                          </div>
                          <div className="date-head col-md-4 col-4">
                            <h6>DATE</h6>
                          </div>
                          <div className="status-head col-md-3 col-4">
                            <h6>STATUS</h6>
                          </div>

                          <div className="total-head col-md-2">
                            <h6>ACTION</h6>
                          </div>
                        </div>
                        <hr />
                        <div className="body-bottom">
                          {returnOrder?.map((order, index) => (
                            <div className="body-button-outer row" key={index}>
                              <div className="order-body col-md-1 col-3">
                                <p>{index + 1}</p>
                              </div>
                              <div className="date-body col-md-4 col-4">
                                <p>{formatDate(order?.orderId?.createdAt)}</p>
                              </div>
                              <div className="status-body col-md-3 col-4">
                                <p>{order?.status}</p>
                              </div>
                              {/* <div className="total-body col-md-2">
                                <p>{order?.total_amount}</p>
                              </div> */}
                              <div className="action-body col-md-2 col-3 row">
                                <div className="view  col-md-12 col-8">
                                  <button
                                    className="view-but"
                                    onClick={() => {
                                      navigate(
                                        `/returnOrderConfirmation/${order._id}`
                                      );
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </div>
                        {/* <div className="body-next">
                          <button>NEXT</button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* // for the mobile widht */}
              </div>
            )}
            {value === 3 && (
              <div className="wallet">
                <div className="wallet-outer row">
                  <div className="wallet-section-1  col-md-3 ">
                    <div className="section-1-outer row">
                      <div className="head col-12">
                        <h6>My Wallet</h6>
                      </div>
                      <div className="body  col-12">
                        <div className="button-1 col-md-12">
                          <div className="button-outer d-flex flex-column justify-content-center align-item-center">
                            <i
                              class="bi bi-plus-circle-fill"
                              onClick={() => setGetAmountValue(true)}
                            ></i>
                            <button
                              className="topup"
                              onClick={() => setGetAmountValue(true)}
                            >
                              Wallet TopUp
                            </button>
                            {getAmountValue && (
                              <div>
                                <input
                                  type="number"
                                  value={amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                  placeholder="Enter amount"
                                  style={{ width: "114px" }}
                                />
                                <button
                                  className="add-amount"
                                  onClick={addWalletAmount}
                                >
                                  Add Amount
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="button-2 col-4 col-md-12">
                          <div className="button-outer d-flex flex-column justify-content-center align-item-center">
                            <i class="bi bi-credit-card-2-front-fill"></i>{" "}
                            <p>Transactions</p>
                          </div>
                        </div>
                        <div className="button-3 col-4 col-md-12">
                          <div className="button-outer d-flex flex-column justify-content-center align-item-center">
                            <i class="bi bi-people-fill"></i> <p>Referrals</p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="wallet-section-2 col-md-9">
                    <div className="section-2-outer">
                      <div className="head">
                        <h6>Balance</h6>
                        <p>₹{walletAmount}</p>
                      </div>
                      <hr />
                      <div className="body"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {value === 4 && (
              <div className="account">
                <div className="account-outer">
                  <div className="head">
                    <h5>
                      Hello!{" "}
                      {userData?.fullName && userData.fullName.split(" ")[0]}
                    </h5>
                  </div>
                  <h2>User Profile</h2>
                  <div className="body mt-2">
                    <div className="container body-outer">
                      <form onSubmit={handleSubmit}>
                        <div className="row input-part">
                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="fullName">Full Name</label>
                            <input
                              type="text"
                              name="fullName"
                              id="fullName"
                              value={userData.fullName}
                              onChange={handleChangeUserInfo}
                              placeholder="Full Name"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="address">Address</label>
                            <input
                              type="text"
                              name="address"
                              id="address"
                              value={userData.address}
                              onChange={handleChangeUserInfo}
                              placeholder="Address"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="email">Email</label>
                            <input
                              type="text"
                              name="email"
                              id="email"
                              value={userData.email}
                              onChange={handleChangeUserInfo}
                              placeholder="Email"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="city">City</label>
                            <input
                              type="text"
                              name="city"
                              id="city"
                              value={userData.city}
                              onChange={handleChangeUserInfo}
                              placeholder="City"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="landmark">Landmark</label>
                            <input
                              type="text"
                              name="landmark"
                              id="landmark"
                              value={userData.landmark}
                              onChange={handleChangeUserInfo}
                              placeholder="Landmark"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="state">State</label>
                            <input
                              type="text"
                              name="state"
                              id="state"
                              value={userData.state}
                              onChange={handleChangeUserInfo}
                              placeholder="State"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="phone">Phone</label>
                            <input
                              type="text"
                              name="phone"
                              id="phone"
                              value={userData.phone}
                              onChange={handleChangeUserInfo}
                              placeholder="Phone"
                            />
                          </div>

                          <div className="input1 col-sm-12 col-md-6">
                            <label htmlFor="pincode">Pincode</label>
                            <input
                              type="text"
                              name="pincode"
                              id="pincode"
                              value={userData.pincode}
                              onChange={handleChangeUserInfo}
                              placeholder="Pincode"
                            />
                          </div>
                        </div>

                        <div className="button-part mb-3 mt-3">
                          <button className="btn " type="submit">
                            Save Changes
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {value === 5 ? <div className="logout"></div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Myaccount;
